import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Link } from '@/core/i18n/navigation';
import { Brand as BrandType } from '@/shared/types/blocks/common';
export function BrandLogo(t0) {
  const $ = _c(11);
  const {
    brand
  } = t0;
  const t1 = brand.url || "";
  const t2 = brand.target || "_self";
  const t3 = `flex items-center space-x-2 ${brand.className}`;
  let t4;
  if ($[0] !== brand.logo || $[1] !== brand.title) {
    t4 = brand.logo && <Image src={brand.logo.src} alt={brand.title ? "" : brand.logo.alt || ""} width={brand.logo.width || 100} height={brand.logo.height || 100} className="h-10 w-auto" />;
    $[0] = brand.logo;
    $[1] = brand.title;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== brand.title) {
    t5 = brand.title && <span className="text-lg font-medium">{brand.title}</span>;
    $[3] = brand.title;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <Link href={t1} target={t2} className={t3}>{t4}{t5}</Link>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}